import { useAuthStore } from '@/stores/auth';

let pulse = null;

export function usePulse() {
  if (pulse) {
    return;
  }

  const authStore = useAuthStore();

  pulse = setInterval(() => {
    authStore.pulse().then();
  }, 60 * 1000);
  authStore.pulse().then();
}
